import React, {useEffect, useMemo, useState} from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import classNames from 'classnames';
import { Grid, MenuItem, TextField } from "@mui/material";
import {
  setCompany,
} from '../../../app/slices/companiesSlice';
import {
    showModal,
} from '../../../app/slices/modalSlice';
import _ from "lodash";
import useSectors from "../../../hooks/useSectors";
import CompanyEditField from "./CompanyEditField";

const CompanyInfoForm = ({ isCreate, canEdit, model, errors, onFieldChange, onFieldSave}) => {
    const { sectors } = useSectors();
    const [allSectors, setAllSectors] = useState([]);
    const { t } = useTranslation('CompanyCreateScreen', { keyPrefix: 'InfoForm' });
    const [currentEdit, setCurrentEdit] = useState('');
    
    const infoFields = useMemo(() => {
        return [
            {
                name: 'name',
                modelName: 'Name',
                required: true,
            },
            {
                name: 'nip',
                modelName: 'NIP',
            },
            {
                name: 'allSectors',
                modelName: 'AllSectors',
                required: true,
                items: allSectors,
                multiple: true,
            },
            {
                name: 'email',
                modelName: 'Email',
                required: true,
            },
            {
                name: 'status',
                modelName: 'Status',
            },
            {
                name: 'ownName',
                modelName: 'OwnName',
            }
        ];
    }, [allSectors]);
    

    

    useEffect(() => {
        const newArray = sectors.map(sector => {
            return {
                value: sector.id,
                text: sector.name
            }
        })
        
        setAllSectors(newArray);
    }, [sectors]);

    const checkIfDisabled = (field) => !isCreate && (!canEdit || field !== currentEdit);
    const getErrorMessage = (field) => _.find(errors, (error) => error.field === field);
    const handleFieldChange = (field, value) => onFieldChange(field, value);
    const handleFieldSave = (field, value) => {
        onFieldSave(field, value);
        setCurrentEdit(null);
    }

    useEffect(() => {
        document.documentElement.style.setProperty('--blocked-sector-position-text', `'${t('blockedSectorPositionText')}'`);
    }, [t])

    return (
        <div className={classNames('fk-form-section', {'edit-mode': canEdit})}>
            <h3 className="title">
                {t('title')}
            </h3>
            <Grid container spacing={2}>
                {infoFields?.map(({name, modelName, required, items, multiple}, index) => (
                    <React.Fragment key={index}>
                        <CompanyEditField
                            key={index}
                            name={name}
                            model={model}
                            modelName={modelName}
                            required={required}
                            items={items}
                            multiple={multiple}
                            onChange={handleFieldChange}
                            onEditClick={setCurrentEdit}
                            onSaveClick={handleFieldSave}
                            disabled={checkIfDisabled(name)}
                            canEdit={canEdit}
                            errorMessage={getErrorMessage(name)}
                            currentEdit={currentEdit}
                            t={t}
                            value={model ? model[name] ?? '' : !!items ? '' : ''}
                        />
                    </React.Fragment>
                ))}
            </Grid>
        </div>
    );
};

const mapStateToProps = (state) => ({
    errors: state.companies.errors,
});

const actions = {
    setCompany,
    showModal,
};

export default connect(mapStateToProps, actions)(CompanyInfoForm);